module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEYSURBVGhD7ZhbCsJADEW7Dv3VJekaFVyXDwTxsQC9EQJhyNhhAk0qOXA+mjLTO+1HQ4YkSZJwbOEJvp2kZ1OGbi5Q23hKz7AbbUMPu9E287AbbTMPmSfcw+X3qgFtMw8Zvr7CBRXGkJt4ysgafYlR5AJPGVl7UGEMucBTplavUi7wkqnVq9BPpFw0tUfIlPdG8W4lKPwGMuX92ZEH8CYP0MMaHiD1MWUAi00/MisreINaAKtNrYQVevPaw602N3NWXlAL0Osd7mBzO22lDDA78gDezPYAtSbQPOeZil/zJNOcZyq04NLwaKGl4dFCS8OjhZaGRwstDY8WWhoeLbQ0PFpoaXh+zZPknCcstVainPMkSZL8DcPwAWn8g/T0lSmCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-roller/dark/48.png
// module id = 2309
// module chunks = 2